import {useState} from 'react'

const SortableHeaders = ({
  label,
  field,
  handleSorting,
  sorting,
}: {
  label: string
  field: string
  handleSorting: any
  sorting: any
}) => {
  return (
    <th className='py-5 px-3' onClick={() => handleSorting(field)} style={{cursor: 'pointer'}}>
      {label}{' '}
      <i
        className={`fa ${
          sorting.sort_field === field
            ? sorting.sort_order === 'asc'
              ? 'fa-sort-up'
              : 'fa-sort-down'
            : 'fa-sort'
        } fa-xs`}
      ></i>
    </th>
  )
}

export default SortableHeaders
